namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoItem2ExemptService {
        export const baseUrl = 'AdvPromo/PsAdvPromoItem2Exempt';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoItem2ExemptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoItem2ExemptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoItem2ExemptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoItem2ExemptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoItem2Exempt/Create",
            Update = "AdvPromo/PsAdvPromoItem2Exempt/Update",
            Delete = "AdvPromo/PsAdvPromoItem2Exempt/Delete",
            Retrieve = "AdvPromo/PsAdvPromoItem2Exempt/Retrieve",
            List = "AdvPromo/PsAdvPromoItem2Exempt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoItem2ExemptService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
